import { defineComponent } from '@vue/composition-api';
import { ContentLoaderSize } from './constants.js';

var script = defineComponent({
    name: 'SbContentLoader',
    props: {
        size: {
            type: String,
            required: false,
            default: ContentLoaderSize.Small,
        },
    },
    setup: function () {
        return {
            ContentLoaderSize: ContentLoaderSize,
        };
    },
});

export default script;
